// src/pages/History/MedievalHistory/FeudalJapanGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history/Middle_Ages_-_Feudal_Japan.png';

function HistoryPageJapanGo() {
  return (
    <QuizPage
      title="History: Feudal Japan"
      subTopic="Feudal Japan"
      backgroundImage={historyImage}
      returnPath="/History-Feudal-Japan"
    />
  );
}

export default HistoryPageJapanGo;   